var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/greyCross.07b709a4.png","uri@3x": __webpack_public_path__ + "static/media/greyCross.417360f3.png","uri@2x": __webpack_public_path__ + "static/media/greyCross.e97c6644.png",
    width: 16,
    height: 16
});